import { render, staticRenderFns } from "./CreateRequestView.vue?vue&type=template&id=07d87dcb&scoped=true"
import script from "./CreateRequestView.vue?vue&type=script&lang=js"
export * from "./CreateRequestView.vue?vue&type=script&lang=js"
import style0 from "./CreateRequestView.vue?vue&type=style&index=0&id=07d87dcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d87dcb",
  null
  
)

export default component.exports